import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Box } from '@mui/material'

export const CollaboratorsModal = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`

export const CardsGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const CollaboratorsCard = styled(Box)<{ borderColor?: string }>`
  ${({ borderColor }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    border: 2px solid ${borderColor || 'rgba(30, 64, 175, 0.24)'};
    border-radius: 16px;
    background: #FFFFFF;
    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.16);
    overflow: hidden;
  `}
`

export const CardContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  z-index: 1;
  margin-right: 30px;
`

export const IconContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TotalNumber = styled.div<{ color?: string }>`
  ${({ theme, color }) => css`
    font-size: 48px;
    font-weight: 700;
    color: ${color || '#1E40AF'};
    line-height: 1;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`

export const CardLabel = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: auto;
  object-fit: contain;
`

export const FiltersContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const FilterRow = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const ButtonsContainer = styled(Box)`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: flex-end;
`

export const TableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CollaboratorInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Avatar = styled(Box)`
  ${({ theme }) => css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${theme.colors.primary};
    color: ${theme.colors.lightest};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  `}
`

export const CollaboratorDetails = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const CollaboratorName = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    line-height: 1.2;
  `}
`

export const CollaboratorRegistration = styled(Box)`
  ${() => css`
    font-size: 12px;
    font-weight: 400;
    color: #6B7280;
    line-height: 1.2;
  `}
`

export const StatusBadge = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    border-radius: 16px;
    background: ${color}20;
    color: ${color};
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    min-width: 200px;
  `}
`
